export default __webpack_public_path__ + "assets/images/d2aeb2c8cae21ccfb7004e5140401336.svg";